export default __webpack_public_path__ + "media/images/no_avatar-3fc3dd1d.png";